

export enum ECreditType {
    sms = 'sms',
    minutes = 'minutes',
    contacts = 'contacts',
    leedbucks = 'leedbucks',
}
  
export const creditTypeAsString = (type: ECreditType | string, icon = true): string => {
    switch (type) {
        case ECreditType.sms:
            return icon ? "💬" : "SMS";
        case ECreditType.minutes:
            return icon ? "⏰" : "Minutes";
        case ECreditType.contacts:
            return icon ? "👤" : "Contacts";
        case ECreditType.leedbucks:
            return icon ? "🪙" : "Leedbucks";
        default:
            return type.toString();
    }
};

export const creditTypeAsInvoiceString = (type: ECreditType | string): string => {
    switch (type) {
        case ECreditType.sms:
            return "sms";
        case ECreditType.minutes:
            return "min appels";
        default:
            return type;
    }
};